import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.article `
  --borderRadius: 6px;
  --bgColor: ${brand.white};
  --fgColor: ${brand.primary.blue};

  display: grid;
  grid-template-rows: auto 1fr;
  border-radius: var(--borderRadius);
`;
const ImageWrapper = styled.div `
  aspect-ratio: 340 / 196;
  position: relative;
  overflow: hidden;
  width: 100%;
  border-top-left-radius: var(--borderRadius);
  border-top-right-radius: var(--borderRadius);

  @media ${from(Device.Tablet)} {
    aspect-ratio: 428 / 370;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled.div `
  --shadowColour: rgba(0, 0, 0, 0.05);

  color: var(--fgColor);
  background-color: var(--bgColor);
  padding: ${fluid(16, 20)};
  border-radius: 0 0 var(--borderRadius) var(--borderRadius);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: -0.1px 1px 1.1px var(--shadowColour), -0.2px 2.7px 3px -0.8px var(--shadowColour),
    -0.4px 6.3px 7.1px -1.7px var(--shadowColour), -0.9px 5px 16.9px -2.5px var(--shadowColour);

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(22, 26)};
    margin: auto 0 8px;

    svg {
      width: 13px;
    }

    @media ${from(Device.Tablet)} {
      margin-bottom: 0;
    }
  }
`;
const Date = styled.time `
  ${paragraphSmall};
  ${fonts.lato.bold};

  text-transform: uppercase;
  margin: 0;
  opacity: 0.5;
`;
const Name = styled.h3 `
  ${fonts.apparat.semiBold};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  margin: 0;
`;
const Description = styled.p `
  display: none;

  @media ${from(Device.Tablet)} {
    ${paragraphSmall};

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 0 16px;
  }
`;
const ArticleCardStyles = {
    Container,
    ContentWrapper,
    Date,
    Description,
    Img,
    ImageWrapper,
    Name,
};
export default ArticleCardStyles;
